export default __webpack_public_path__ + "static/media/element_spec_15.1d9c91ca.webp";